import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.dynamicDomClasses, "rounded h-[calc(100%-2px)] inline-flex items-center py-2 border-gray-400 rounded-sm shadow-sm cursor-default px-4"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}